import React from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function CartButton({ className = "", variant = "light" }) {
  const { count, setOpen } = useCart();

  const base =
    "relative inline-flex items-center justify-center h-11 w-11 rounded-full transition-all hover:-translate-y-0.5";
  const variants = {
    light: "border border-qh-line bg-white hover:bg-[#FFFBFB] text-qh-ink",
    ghost: "bg-transparent text-qh-ink hover:bg-white/60",
  };

  return (
    <button
      onClick={() => setOpen(true)}
      className={`${base} ${variants[variant] || variants.light} ${className}`}
      aria-label={`Warenkorb (${count})`}
      data-testid="cart-button"
    >
      <ShoppingBag className="w-[18px] h-[18px]" strokeWidth={1.75} />
      {count > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] rounded-full bg-qh-rose text-white text-[10px] font-semibold flex items-center justify-center px-1 border-2 border-white"
          data-testid="cart-count"
        >
          {count}
        </span>
      )}
    </button>
  );
}
